<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="3">
        <b-card no-body class="bg-primary" @click="goto('orders/0')">
          <b-card-body class="pb-0">
            <i
              class="fa pull-right fa-3x"
              :class="pendings && pendings.length > 0 ? 'fa-star text-warning' : 'fa-star-o'"
            ></i>
            <h4 class="mb-0">{{pendings ? pendings.length : 0 | numberformat}}</h4>
            <p>{{t(['New Orders','ອໍເດີໃໝ່'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="3">
        <b-card no-body class="bg-light" @click="goto('orders/1')">
          <b-card-body class="pb-0">
            <i class="icon-clock pull-right fa-3x" size="5"></i>
            <h4 class="mb-0">{{processings ? processings.length : 0 | numberformat}}</h4>
            <p>{{t(['Processing Orders','ອໍເດີກຳລັງເຮັດ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="3">
        <b-card no-body class="bg-warning" @click="goto('orders/2')">
          <b-card-body class="pb-0">
            <i class="fa fa-send pull-right fa-3x"></i>
            <h4 class="mb-0">{{sendings ? sendings.length : 0 | numberformat}}</h4>
            <p>{{t(['Sending Orders','ອໍເດີກຳລັງໄປສົ່ງ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="3">
        <b-card no-body class="bg-success" @click="goto('orders/3')">
          <b-card-body class="pb-0">
            <i class="icon-check pull-right fa-3x"></i>
            <h4 class="mb-0">{{completes ? completes.length : 0 | numberformat}}</h4>
            <p>{{t(['Completed Orders','ອໍເດີສົ່ງແລ້ວ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="3">
        <b-card no-body class="bg-danger" @click="goto('users')">
          <b-card-body class="pb-0">
            <i class="fa fa-trash pull-right fa-3x"></i>
            <h4 class="mb-0">{{rejects ? rejects.length : 0 | numberformat}}</h4>
            <p>{{t(['Rejected Orders','ອໍເດີຍົກເລີກ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="3">
        <b-card no-body class="bg-purple text-white" @click="goto('orders')">
          <b-card-body class="pb-0">
            <i class="fa fa-address-book pull-right fa-3x"></i>
            <h4 class="mb-0">{{orders ? orders.length : 0 | numberformat}}</h4>
            <p>{{t(['All Orders','ອໍເດີທັງໝົດ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- <b-col cols="3">
        <b-card no-body class="bg-pink text-white" @click="goto('users')">
          <b-card-body class="pb-0">
            <i class="icon-people pull-right fa-3x"></i>
            <h4 class="mb-0">{{users ? users.length : 0 | numberformat}}</h4>
            <p>New Users</p>
          </b-card-body>
        </b-card>
      </b-col>-->

      <b-col cols="3">
        <b-card no-body class="bg-dark" @click="goto('users')">
          <b-card-body class="pb-0">
            <i class="icon-people pull-right fa-3x"></i>
            <h4 class="mb-0">{{users | numberformat}}</h4>
            <p>{{t(['Total Users','ລູກຄ້າທັງໝົດ'])}}</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <b-card :header="t(['Weekly Orders','ອໍເດີປະຈຳອາທິດ'])" header-bg-variant="primary">
          <div class="chart-wrapper">
            <OrdersChart />
          </div>
        </b-card>
      </b-col>

      <b-col cols="6">
        <b-card :header="t(['Monthly Users','ຜູ້ໃຊ້ປະຈຳເດືອນ'])" header-bg-variant="success">
          <div class="chart-wrapper">
            <UsersChart />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- <audio id="audio" src="http://www.noiseaddicts.com/samples_1w72b820/3720.mp3" /> -->
    <audio
      id="audio"
      src="https://firebasestorage.googleapis.com/v0/b/naoki-c4da8.appspot.com/o/noti.mp3?alt=media&token=7c8c044d-5c3b-4566-a171-917534660152"
    />
  </div>
</template>

<script>
import firebase from "firebase";
import OrdersChart from "../../components/OrdersChart";
import UsersChart from "../../components/UsersChart";
import Swal from "sweetalert2";
import Axios from "axios";

export default {
  name: "dashboard",
  components: { OrdersChart, UsersChart },
  computed: {
    pendings: function() {
      return _.filter(this.orders, o => o.orderStatus === 0);
    },
    processings: function() {
      return _.filter(this.orders, o => o.orderStatus === 1);
    },
    sendings: function() {
      return _.filter(this.orders, o => o.orderStatus === 2);
    },
    completes: function() {
      return _.filter(this.orders, o => o.orderStatus === 3);
    },
    rejects: function() {
      return _.filter(this.orders, o => o.orderStatus === -1);
    }
  },
  data: function() {
    return {
      users: null,
      orders: null
    };
  },
  mounted() {
    Axios.get("app/admins").then(res => {
      this.users = res.users;
    });
    const today = this.moment()
      .startOf("day")
      .toDate();
    firebase
      .firestore()
      .collection("orders")
      .where("createDate", ">=", today)
      .orderBy("createDate", "desc")
      .onSnapshot(snapshot => {
        let orders = [];
        snapshot.forEach(doc => {
          let item = doc.data();
          item.id = doc.id;
          if (item.orderStatus === 0) {
            this.play();
          }
          orders.push(item);
        });
        this.orders = orders;
      });
  },
  methods: {
    goto(url) {
      this.$router.replace(url);
    },
    play() {
      document.getElementById("audio").play();
    }
  }
};
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>
